// extracted by mini-css-extract-plugin
export default {"sticky":"sticky--UR9815OVZU","stickySentinel":"stickySentinel--Fe6RfpzPjq"};